export const setShow = 'MCT_LOADER/setShow'
